module.exports = __webpack_public_path__ + "img/Lightbulb-Moment_dark.b8832a6b.png";